import BaseModel from "../base/baseModel";

export default class CondicaoModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    dataCriacao: Date = null;
}
